import { useAssetFrontendDesign } from '@/custolink-views/asset_frontend/redesigns/assetFrontendDesign'
import AssetViewClassic, { type AssetViewProps } from '@/custolink-views/asset_frontend/asset_view/AssetViewClassic'
import AssetViewDesign from '@/custolink-views/asset_frontend/asset_view/AssetViewDesign'

export type { AssetViewProps }

/**
 * The asset view switch: new or classic design, per `useAssetFrontendDesign`
 * (new design by default; localStorage `design=old` shows the classic one).
 */
export default function AssetView(props: AssetViewProps) {
  return useAssetFrontendDesign() ? <AssetViewDesign {...props} /> : <AssetViewClassic {...props} />
}
